// src/components/profiles/GuestUser/GuestUserProfile.tsx

"use client";

import React, { useState } from "react";
import { PageSkeleton } from "../../common";

import { GuestProfileType } from "../../../types/profiles/guestProfileTypes";

import GuestProfileHeader from "./components/header/GuestProfileHeader";
import GuestMomentsSection from "./components/moments/GuestMomentsSection";
import FriendsDrawer from "../../shared/profile-actions/FriendsDrawer";

import "./GuestUserProfile.css";

interface GuestUserProfileProps {
  guest: GuestProfileType;
}

const GuestUserProfile: React.FC<GuestUserProfileProps> = ({ guest }) => {
  const customUser = guest?.user;

  /* drawer state */
  const [friendsOpen, setFriendsOpen] = useState(false);

  if (!customUser) {
    return (
      <PageSkeleton
        variant="profile"
        showTextLines={8}
        className="profile-loading-skeleton"
      />
    );
  }

  const friends = guest?.friends ?? [];

  return (
    <div className="guest-profile-page">
      <GuestProfileHeader
        guest={guest}
        onOpenFriends={() => setFriendsOpen(true)}
      />

      <div className="post-guest-carousel-indicators tl-indicator-aurora">
        <div className="post-guest-indicators-container">
          <span className="guest-indicator">
            Moment
          </span>
        </div>
      </div>

      <GuestMomentsSection />

      {/* render drawer outside header */}
      <FriendsDrawer
        open={friendsOpen}
        onClose={() => setFriendsOpen(false)}
        friends={friends}
      />
    </div>
  );
};

export default GuestUserProfile;